import React from 'react';
import PropTypes from 'prop-types';

import Warning from 'jsx/elements/messages/Warning';
import { verifyRegnoListString } from 'utils/strings';
import SSNTextInputBox from 'components/SSNTextInputBox';
import ExclusionUploadResult from './ExclusionUploadResult';
import { api } from 'api';

class ExclusionUpload extends React.Component {
  defaultState = () => {
    return {
      regnoText: '',
      error: '',
      loading: false,
      uploadResult: null,
      openResult: false
    };
  };
  state = this.defaultState();

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) {
      this.setState(this.defaultState());
    }
  }

  onInputClose = () => {
    this.setState(this.defaultState());
  };

  onResultClose = () => {
    this.setState({ openResult: false });
    setTimeout(() => {
      this.setState({ uploadResult: null });
    }, 1000);
  };

  onSubmit = () => {
    if (this.state.regnoText === '') {
      this.setState({
        error: this.props.t('portfolio_exclusionUpload_error_no_regnos')
      });
    } else {
      const verify = verifyRegnoListString(this.state.regnoText);
      const { allRegnos, invalidRegnos } = verify;
      if (invalidRegnos.length > 0) {
        this.setState({
          error: this.props.t(
            'portfolio_exclusionUpload_error_invalid_regnos',
            invalidRegnos.join(', ')
          )
        });
      } else {
        this.setState({ loading: true, error: '' });
        api.paymentBehavior.addToExclusionList(allRegnos).then(data => {
          if (data) {
            this.props.update();
            this.onInputClose();
            setTimeout(() => {
              this.setState({ uploadResult: data, openResult: true });
            }, 500);
          }
        });
      }
    }
  };

  render() {
    return (
      <div>
        {this.state.error && (
          <Warning
            messageHeader={this.state.error}
            messageType="alert"
            onClose={() => this.setState({ error: '' })}
          />
        )}
        <ExclusionUploadResult
          data={this.state.uploadResult}
          onClose={this.onResultClose}
          isOpen={this.state.openResult}
        />
        <SSNTextInputBox
          title={this.props.t('portfolio_exclusionUpload_ssnTextInput_title')}
          onChange={(name, value) => this.setState({ [name]: value })}
          regnoText={this.state.regnoText}
          onSubmit={this.onSubmit}
          loading={this.state.loading}
        />
        <hr style={{ marginBottom: '1.5em', marginTop: 0 }} />
      </div>
    );
  }
}

ExclusionUpload.propTypes = {
  isOpen: PropTypes.bool.isRequired
};

export default ExclusionUpload;
